module.exports = require('./helpers/bundle-url').getBundleURL('2av5d') + "trach.f6420adb.jpg";